import CartItems from './cartItems';
import selectors from './selectors';

/**
 * Utility function to update the cart count.
 *
 * @param  {number} to The new number.
 * @return void
 */
const updateCartCount = (to) => {
    const { cart } = selectors;
    if (typeof to === 'undefined') {
        CartItems.fetch();
        to = CartItems.models.length; // eslint-disable-line
    }

    const counter = $(cart.folder);

    if (to > 0) {
        counter.addClass('show-count')
            .attr('data-content', to);
    } else {
        counter.removeClass('show-count')
            .attr('data-content', to);
    }
};

export default updateCartCount;
